import ProjectStats from "./components/ProjectStats";
import { useState } from "react";
import {
  useGetCreatorProjectsQuery,
  useGetCreatorProjectsV2Query,
} from "@/redux/feature/creatorProject/creatorProjectApi";
import { useAppSelector } from "@/redux/hooks/hooks";
import { PlanDetailsTypes, PreferredVideoTypesProps } from "@/types/types";
import {
  TResponseOrderDetails,
  TResponseOrderVideos,
} from "@/types/projectType";
import ProjectsTable from "./components/ProjectsTable";
import { useCreatorStatus } from "@/hooks/useCreatorStatuts";
import BlurPopUp from "../jobs/components/BlurPopUp";
import Pagination from "@/components/ui/Pagination";

export type TFilterOptions = "all" | "completed" | "in-progress";

export type TCreatorProjectResponseType = {
  _id: string;
  quantity: number;
  order_id: TResponseOrderDetails;
};
export type TProjectsMeta = {
  page: number;
  limit: number;
  totalPages: number;
  totalProjects: number;
  totalInProgress: number;
  totalCompleted: number;
};

const Projects = () => {
  // const [projects, setProjects] = useState<ResponseType | null>(null);
  const [filter, setFilter] = useState<TFilterOptions>("all");
  const [page, setPage] = useState(1);

  const userEmail = useAppSelector((state) => state.auth.user?.email);

  const {
    shouldShowPopup,
    status,
    isError: isStatusError,
  } = useCreatorStatus(userEmail as string);
  const email = useAppSelector((state) => state.auth.user?.email);

  const {
    data: projectsData,
    isLoading,
    isError,
    isFetching,
  } = useGetCreatorProjectsV2Query(
    [
      { name: "email", value: encodeURIComponent(email as string) },
      { name: "limit", value: 10 },
      { name: "page", value: page },
      {
        name: "project_status",
        value: filter,
      },
    ],
    {
      skip: !email || isStatusError || shouldShowPopup,
    }
  );

  const projects: TCreatorProjectResponseType[] = projectsData?.data?.data;
  const projectsMeta: TProjectsMeta = projectsData?.data?.meta;
  const renderPopup = () => {
    if (shouldShowPopup) {
      return <BlurPopUp status={status} />;
    }
    return null;
  };

  // console.log(projects);

  return (
    <div className="mb-20">
      {shouldShowPopup && (
        <div className="absolute w-full h-screen top-0 left-0  backdrop-blur-sm z-20 flex justify-center items-center">
          <div className=" rounded-xl shadow-lg max-w-lg w-full mx-auto">
            {renderPopup()}
          </div>
        </div>
      )}
      <div className="px-4 md:px-11 mt-7 mb-10">
        <h1 className="text-xl mb-7 font-semibold">Projects</h1>
        <ProjectStats
          data={projectsMeta}
          filter={filter}
          setFilter={setFilter}
        />
      </div>
      <div className="px-4 md:px-11 space-y-11 pb-20">
        <>
          {projects?.length < 0 ? (
            <p>No Projects to show</p>
          ) : (
            <>
              {isError || isStatusError ? (
                <>
                  <p className="py-20 flex justify-center items-center font-semibold animate-pulse">
                    Some thing Went Wrong...
                  </p>
                </>
              ) : (
                <ProjectsTable
                  isLoading={isLoading}
                  isFetching={isFetching}
                  setFilter={setFilter}
                  filter={filter}
                  data={projects}
                />
              )}
            </>
          )}
        </>
        <Pagination
          currentPage={page}
          setPage={setPage}
          totalPages={projectsMeta?.totalPages}
        />
      </div>
    </div>
  );
};

export default Projects;
